import type { BillingProfileDomainQueryModel } from '@mntn-dev/domain-types'

export function billingProfileHasValidAddress(
  billingProfile: BillingProfileDomainQueryModel
) {
  return billingProfile.hasBillingAddress
}
